enum FeatureFlags {
  HAMS_CCP_OPEN_QUOTE_MIGRATION = 'hams_ccp_open_quote_migration',
  CART_STOP_SELLING_JWM = 'cart-stop-selling-jwm',
  CART_SPORK_INITIATIVE_JSW_TO_JIRA_REBRANDING = 'cart-spork-initiative-jsw-to-jira-rebranding',
}

export default FeatureFlags;
